import getOcTheme from '../../../theme/services/getOcTheme';

const { palette, spacing, typography } = getOcTheme();

export default {
  '& .oc-tableContainer': {
    display: 'block',
    overflow: 'auto',
    maxWidth: `calc(100vw - ${spacing(2)})`,
  },
  '& table': {
    border: `1px solid ${palette.layout.line.divider}`,
    marginBottom: spacing(3),
    tableLayout: 'fixed',
    fontSize: 'inherit',
    fontWeight: 'inherit',

    '& figure': {
      width: 'auto',
    },

    '& figcaption': {
      whiteSpace: 'nowrap',
    },

    '& thead': {
      background: palette.primary.main,
      color: palette.text.onContrasted,

      '& tr': {
        fontWeight: typography.fontWeightRegular,
        textAlign: 'left',

        '& p': {
          color: palette.text.onContrasted,
          margin: 0,
        },
      },
    },

    '& td, & th': {
      padding: spacing(1),
      '& p:last-child': {
        margin: 0,
      },
    },

    '& td': {
      verticalAlign: 'top',
      '& ul': {
        margin: `0 0 0 ${spacing(2)}`,
        padding: 0,
      },
    },

    '& tbody': {
      '& tr': {
        '&:nth-child(even)': {
          backgroundColor: palette.background.primary,
        },
        '&:nth-child(odd)': {
          backgroundColor: palette.background.alternative,
        },
      },
    },
  },
};
